import { FC } from "react";
import classNames from "classnames";

import Button from "../../../../components/Button/Button";
import InputFieldAuth from "../../../../components/InputFieldAuth/InputFieldAuth";
import { AddClientPanelProps } from "./types";

import styles from "./AddClientPanel.module.css";

const AddClientPanel: FC<AddClientPanelProps> = ({
  isModal = false,
  addTab,
  onTabChange,
  clientEmail,
  onClientEmailChange,
  label,
  onLabelChange,
  onLinkSubmit,
  addLoading,
  addError,
  createFirstName,
  onCreateFirstNameChange,
  createLastName,
  onCreateLastNameChange,
  createEmail,
  onCreateEmailChange,
  createPassword,
  onCreatePasswordChange,
  createLabel,
  onCreateLabelChange,
  onCreateSubmit,
  createLoading,
  createError,
  isCreateValid,
}) => {
  return (
    <section
      className={classNames(styles["panel"], isModal && styles["is-modal"])}
      aria-label="Add client"
    >
      <div className={styles["panel__tabs"]} role="tablist" aria-label="Add client method">
        <button
          type="button"
          role="tab"
          aria-selected={addTab === "link"}
          className={classNames(
            styles["panel__tab"],
            addTab === "link" && styles["is-active"],
          )}
          onClick={() => onTabChange("link")}
        >
          Link Existing
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={addTab === "create"}
          className={classNames(
            styles["panel__tab"],
            addTab === "create" && styles["is-active"],
          )}
          onClick={() => onTabChange("create")}
        >
          Create New
        </button>
      </div>

      {addTab === "link" && (
        <div className={styles["panel__body"]} role="tabpanel">
          <div className={styles["panel__form"]}>
            <InputFieldAuth
              placeholder="Client email"
              type="email"
              value={clientEmail}
              onChange={(e) => onClientEmailChange(e.target.value)}
            />
            <InputFieldAuth
              placeholder="Label (optional)"
              value={label}
              onChange={(e) => onLabelChange(e.target.value)}
            />
            <Button
              type="button"
              label={addLoading ? "Linking…" : "Link Client"}
              typeStyle="fill-dark"
              size="lg"
              className={styles["panel__submit"]}
              onClick={onLinkSubmit}
              disabled={addLoading || !clientEmail.trim()}
            />
          </div>
          {addError && <p className={styles["panel__error"]}>{addError}</p>}
        </div>
      )}

      {addTab === "create" && (
        <div className={styles["panel__body"]} role="tabpanel">
          <div className={styles["panel__create-form"]}>
            <div className={styles["panel__form-row"]}>
              <InputFieldAuth
                placeholder="First name"
                value={createFirstName}
                onChange={(e) => onCreateFirstNameChange(e.target.value)}
              />
              <InputFieldAuth
                placeholder="Last name"
                value={createLastName}
                onChange={(e) => onCreateLastNameChange(e.target.value)}
              />
            </div>
            <InputFieldAuth
              placeholder="Email"
              type="email"
              value={createEmail}
              onChange={(e) => onCreateEmailChange(e.target.value)}
            />
            <InputFieldAuth
              placeholder="Password (min 8 characters)"
              type="password"
              value={createPassword}
              onChange={(e) => onCreatePasswordChange(e.target.value)}
            />
            <InputFieldAuth
              placeholder="Label (optional)"
              value={createLabel}
              onChange={(e) => onCreateLabelChange(e.target.value)}
            />
            <Button
              type="button"
              label={createLoading ? "Creating…" : "Create Client"}
              typeStyle="fill-dark"
              size="lg"
              className={styles["panel__submit"]}
              onClick={onCreateSubmit}
              disabled={createLoading || !isCreateValid}
            />
          </div>
          {createError && <p className={styles["panel__error"]}>{createError}</p>}
        </div>
      )}
    </section>
  );
};

export default AddClientPanel;
